(function($) {
    'use strict';

    // Active l'onglet `index` d'un bloc produits.
    // animate=true : transition fadeOut/fadeIn (clic). animate=false : bascule immédiate (init / hash).
    function activer($sommaireItems, $produits, index, animate) {
        $sommaireItems.removeClass('active');
        $sommaireItems.eq(index).addClass('active');

        if (animate) {
            $produits.fadeOut(300);
            setTimeout(function() {
                $produits.eq(index).fadeIn(400);
            }, 300);
        } else {
            $produits.hide();
            $produits.eq(index).show();
        }
    }

    // Scroll en haut du bloc parent (offset header -150, convention du thème).
    function scrollVersBloc($bloc) {
        $('html, body').animate({ scrollTop: $bloc.offset().top}, 400);
    }

    $(document).ready(function() {

        // Pour chaque bloc produits sur la page
        $('.bloc_produits').each(function() {
            var $bloc = $(this);
            var $sommaireItems = $bloc.find('.sommaire ul li');
            var $produits = $bloc.find('.produits .produit');

            // Vérifier qu'on a le même nombre d'items
            if ($sommaireItems.length !== $produits.length) {
                console.warn('Le nombre d\'items du sommaire ne correspond pas au nombre de produits');
                return;
            }

            // Init : premier produit affiché, premier item actif (sans animation)
            activer($sommaireItems, $produits, 0, false);

            // Curseur pointer pour indiquer que c'est cliquable
            $sommaireItems.css('cursor', 'pointer');

            // Clic sur un item du sommaire
            $sommaireItems.on('click', function() {
                activer($sommaireItems, $produits, $(this).index(), true);
            });
        });

        // Liens #ancre ciblant un item de sommaire : interception en phase capture,
        // AVANT le handler global de 10_script.js (qui scrollerait vers le <li> et
        // ne neutralise pas l'onglet).
        //
        // Deux cas à traiter :
        //  1. Lien same-page → on active l'onglet ciblé localement.
        //  2. Lien cross-page situé dans .bloc_produits .sommaire .liens → on neutralise
        //     10_script.js (qui ferait preventDefault + planterait sur $(hash).offset()
        //     puisque le <li> n'est pas sur la page d'origine) et on laisse le browser
        //     naviguer normalement. Le handler 'load' prendra le relais à l'arrivée.
        document.addEventListener('click', function(e) {
            var a = e.target.closest('a[href*="#"]');
            if (!a || !a.hash) return;

            var samePage = (a.host === location.host && a.pathname === location.pathname);

            if (samePage) {
                var $li = $('.bloc_produits .sommaire ul li' + a.hash);
                if (!$li.length) return; // pas une ancre produit → laisser 10_script gérer

                e.preventDefault();
                e.stopPropagation(); // neutralise le handler global de 10_script.js

                var $bloc = $li.closest('.bloc_produits');
                var $sommaireItems = $bloc.find('.sommaire ul li');
                var $produits = $bloc.find('.produits .produit');

                activer($sommaireItems, $produits, $li.index(), true);
                scrollVersBloc($bloc);
                return;
            }

            // Lien cross-page : on ne neutralise 10_script.js que si le lien provient
            // bien du sommaire d'un bloc produits (sinon on laisse le comportement global).
            if (a.closest('.bloc_produits .sommaire .liens')) {
                e.stopPropagation(); // empêche 10_script.js de preventDefault + planter
                // pas de preventDefault : on veut que le browser charge la page cible.
            }
        }, true); // capture
    });

    // Arrivée sur la page avec un #ancre dans l'URL : activer l'onglet + scroller au bloc.
    $(window).on('load', function() {
        if (!window.location.hash) return;

        var $li = $('.bloc_produits .sommaire ul li' + window.location.hash);
        if (!$li.length) return;

        var $bloc = $li.closest('.bloc_produits');
        var $sommaireItems = $bloc.find('.sommaire ul li');
        var $produits = $bloc.find('.produits .produit');

        activer($sommaireItems, $produits, $li.index(), false);
        scrollVersBloc($bloc);
    });

})(jQuery);
